import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import {
    CoursePackageState,
    CoursePromotionState,
    CourseState,
} from '../../../../../features/types'
import { capitalize } from '../../../../../utils/functions'
import PromoTimer from './PromoTimer'
import { logo, packageBox, packageDiscountBox } from '../style'

interface Props {
    packages: CoursePackageState[]
    course: CourseState
    promotion: CoursePromotionState
}

const PackageDiscountInfo: React.FC<Props> = ({
    packages = [],
    promotion,
    course,
}) => {
    const { formatMessage, locale } = useIntl()
    return (
        <Box sx={packageDiscountBox}>
            <Box sx={packageBox}>
                <Box mr={2}>
                    <img
                        src={course[`image${capitalize(locale)}`]}
                        alt="course-logo"
                        style={logo as React.CSSProperties}
                    />
                </Box>

                <Box>
                    <Box
                        mb={1}
                        fontWeight={500}
                    >
                        {formatMessage({ id: 'packageDiscounts' })}
                    </Box>

                    <Box>
                        {packages.map((item) => (
                            <li key={item.id}>
                                {item[`slogan${capitalize(locale)}`]}
                            </li>
                        ))}
                    </Box>
                </Box>
            </Box>

            {promotion && <PromoTimer promotion={promotion} />}
        </Box>
    )
}

export default PackageDiscountInfo
